export enum Page {
    ClientList = 1,
    StaffList = 2,
    StaffLicenseList = 3,
    ClientContactsList=4,
    CaseList=5
}
